// extracted by mini-css-extract-plugin
export default {"cancelButton":"fSo0IC","copilot":"UP1cE8"};